<template>
  <Secao titulo="a semana da química" id="evento">
    <p>
      A Semana da Química é um evento realizado e sediado pelo Instituto Federal Goiano (IF Goiano) 
      - Campus Iporá, que acontece desde 2017. O objetivo principal deste evento é proporcionar aos 
      seus participantes o contato com diferentes áreas da Química e ressaltar a importância dessa 
      área do conhecimento no cotidiano de todos. Ressaltamos que contamos com a colaboração de diversos 
      parceiros ao longo desses anos de evento, os quais agradecemos imensamente, e esperamos construir 
      cada vez mais parceiras significativas. 
    </p>
    <p>A oferta desse evento no IF Goiano - Campus Iporá passa por diversos setores de formação dos 
      estudantes e dos servidores. Dentre esses, temos a formação acadêmica, através do aprendizado 
      adquirido em diferentes tópicos da Química e mediante a apresentação de trabalhos acadêmicos 
      na forma de resumo expandido. Outra área de formação é a de comunicação, na qual os envolvidos 
      terão contato com profissionais de outras instituições (de ensino ou empresa), fomentando assim 
      a formação de parcerias e contatos. Além disso, o evento permite a divulgação dos cursos e da 
      infraestrutura do IF Goiano - Campus Iporá. Dessa forma, a tríade de ensino, pesquisa e extensão, 
      tão importante para nossa instituição de ensino, ganha força e forma. 
    </p>

    <p>
      Nesse ano, a Semana da Química ocorrerá entre os dias 14 a 17 de junho de 2023 e o evento será 
      compartilhado com o ENATI (Encontro Anual de Tecnologia da Informação do Oeste Goiano – ENATI). 
      O tema será
      <b>IF Goiano: transformando a comunidade (IX ENATI e V Semana da Química).</b>
    </p>
    <p>Durante os quatro dias de evento acontecerão palestras, minicursos, oficinas, mostra de robótica, 
      competição de jogos retrô, apresentações culturais e científicas. 
      Os estudantes do IF Goiano - Campus Iporá estão envolvidos na organização e execução desse evento, 
      além de serem um importante público alvo. Contudo, nessa edição tentaremos aproximar nosso contato 
      com estudantes do nível fundamental, médio e superiores de outras instituições de ensino na cidade 
      do Iporá-GO.</p>
  </Secao>
</template>

<script>
import Secao from "../layout/Secao.vue";

export default {
  name: "App",
  components: {
    Secao,
  },
};
</script>

<style scoped>
section#evento {
	background: #fff;
	color: #063342;
}
</style>